const ENV_TO_BASEURL = {
  production: 'https://discounts-secure.mercafacil.com/api/v1',
  beta: 'https://discounts-beta.mercafacil.com/api/v1',
  alpha: 'https://discounts-alpha.mercafacil.com/api/v1',
}

export const getUserSales = (environment, token, documentNo) => {
  const baseUrl = ENV_TO_BASEURL[environment]
  return fetch(`${baseUrl}/user-sales/${documentNo}`, {
    method: 'GET',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
  })
}
